import { list } from './List/List.i18n.ja'
export const login = {
  list,
}
